import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild } from '@angular/core';
import { AjaxService } from 'AjaxService';
import { IAngebotsFormViewvModel, IAngebotsGruppeViewModel } from '@shared/models/angebotsGruppe.model';
import { IDefaultSelectBoxViewModel } from '@shared/models/default-selectBox.model';
import { Observable } from 'rxjs';
import { DxFormComponent } from 'devextreme-angular/ui/form';
import notify from 'devextreme/ui/notify';

import {
  get_formItem_Verwaltungsgericht,
  get_formItem_Inbetriebnahme,
  get_formItem_MitFoerdermassnahmen,
  get_formItem_Schichtdienstsystem,
  get_formItem_GesamtCounts,
  get_formItem_BoolGiltFuerGesamt,
  get_formItem_GiltFuerGesamt,
  get_formItem_Auflagen,
  get_formItem_Angebotsform,
  get_formItem_BeantragtePlaetze,
  get_formItem_GenehmigtePlaetze,
  get_formItem_genehmigteLeitungStellenAnteile,
  get_formItem_GenehmigtePaedStellenAnteile,
  get_formItem_GenehmigtePsychStellenAnteile,
  get_formItem_GenehmigteTherapStellenAnteile,
  get_formItem_GenehmigteSonstigeStellenAnteile,
  get_formItem_GenehmigteSonstigeStellenAnteileBeschreibung,
  get_formItem_AusgabeSatzAngebotsform,
  get_formItem_BetriebserlaubnisWirkungVom,
} from './cz-erl.helper';
import { IDokumentItemViewModel } from '@shared/dokumente/dokument.model';

interface IErlaubnisInitResponse {
  einrichtung: IErlaubnisInitHeResponse;
  isErsdtAntrag: boolean;

  available_Verwaltungsgerichte: IDefaultSelectBoxViewModel[];
  available_AngebotsGruppen: IAngebotsGruppeViewModel[];
}

interface IErlaubnisInitHeResponse {
  eId: number;
  verarbeitungsschluessel: string;
  antragBeId?: number;

  angebotsGruppeId: number;
  verwaltungsgerichtId?: number;

  inbetriebnahme?: Date;
  betriebserlaubnisWirkungVom?: Date;

  mitFoerdermassnahmen: boolean;
  schichtdienstsystem: boolean;

  giltFuerGesamt: string;
  auflagenSatz: string;

  einrichtungsteil: IErlaubnisInitUeResponse;
}

interface IErlaubnisInitUeResponse {
  eId: number;
  name: string;

  angebotsFormId: number;

  genehmigtePlaetze: number;
  genehmigtePaedStellenAnteile?: number;
  genehmigteLeitungStellenAnteile?: number;
  genehmigtePsychStellenAnteile?: number;
  genehmigteTherapStellenAnteile?: number;
  genehmigteSonstigeStellenAnteile?: number;
  genehmigteSonstigeStellenAnteileBeschreibung: string;
  ausgabeSatzAngebotsform: string;

  inbetriebnahme?: Date;
  betriebserlaubnisWirkungVom?: Date;
}

@Component({
  selector: 'cz-erl',
  templateUrl: './cz-erl.component.html',
  styleUrls: ['./cz-erl.component.css'],
  standalone: false,
})
export class ErlaubnisComponent implements OnInit, OnDestroy {
  @ViewChild('form1', { static: false }) form1: DxFormComponent;

  @Input() events: Observable<any>;
  @Input() eId: number;
  @Input() optional: any;
  @Input() isErsdtAntrag: boolean = true;

  @Output() onCloseOk: EventEmitter<any> = new EventEmitter<any>();

  eventsSubscription: any;
  loading: number = 1;

  init_data: IErlaubnisInitResponse = {} as IErlaubnisInitResponse;

  notEditable: boolean = true;
  notAutoUpdate: boolean = false;

  constructor(private ajaxService: AjaxService) {
    this.set_giltFuerGesamt_string = this.set_giltFuerGesamt_string.bind(this);
  }

  formItems = [];

  load(cb: () => void = null) {
    this.startLoading(1);

    this.ajaxService
      .post<IErlaubnisInitResponse>('api/Erlaubnis/GetInit', {
        eId: this.eId,
        isErsdtAntrag: this.isErsdtAntrag
      })
      .subscribe({
        next: (response) => {
          this.init_data = response;

          if (cb) {
            cb();
          }

          this.stopLoading();
        },
        error: (e) => {
          this.stopLoading();
          throw e;
        },
      });
  }

  ngOnInit(): void {
    this.eventsSubscription = this.events.subscribe((event) => this.onEvent(event));
    this.load(() => {
      this.setOptional();

      this.formItems.push({
        itemType: 'group',
        colCount: 2,
        items: [
          get_formItem_Verwaltungsgericht(this.init_data.available_Verwaltungsgerichte),
          get_formItem_BetriebserlaubnisWirkungVom(),
          get_formItem_MitFoerdermassnahmen(),
          get_formItem_Schichtdienstsystem(),
          get_formItem_Inbetriebnahme(),
          get_formItem_GesamtCounts(),
          get_formItem_BoolGiltFuerGesamt(),
          get_formItem_GiltFuerGesamt(this.notEditable),
          get_formItem_Auflagen(),
        ],
      });

      const einr = this.init_data.einrichtung.einrichtungsteil;

      this.formItems.push(
        {
          itemType: 'empty',
          caption: ' ',
        },
        {
          itemType: 'group',
          caption: '\t \t \t' + einr.name,
          colCount: 2,
          items: [
            {
              dataField: 'einrichtungsteil.inbetriebnahme',
              colSpan: 1,
              label: {
                text: 'Inbetriebnahme',
                location: 'left',
              },
              editorType: 'dxDateBox',
              validationRules: [
                {
                  type: 'required',
                  message: "'Inbetriebnahme' wird benötigt!",
                },
              ],
            },
            get_formItem_Angebotsform(this.available_AngebotsFormen, einr.angebotsFormId),
          ],
        },
        {
          itemType: 'group',
          colCount: 2,
          items: [
            get_formItem_BeantragtePlaetze(einr.genehmigtePlaetze),
            get_formItem_GenehmigtePlaetze(einr.genehmigtePlaetze, this.set_giltFuerGesamt_string),
            get_formItem_genehmigteLeitungStellenAnteile(this.set_giltFuerGesamt_string),
            get_formItem_GenehmigtePaedStellenAnteile(this.set_giltFuerGesamt_string),
            get_formItem_GenehmigtePsychStellenAnteile(this.set_giltFuerGesamt_string),
            get_formItem_GenehmigteTherapStellenAnteile(this.set_giltFuerGesamt_string),
            get_formItem_GenehmigteSonstigeStellenAnteile(this.set_giltFuerGesamt_string),
            get_formItem_GenehmigteSonstigeStellenAnteileBeschreibung(),
            get_formItem_AusgabeSatzAngebotsform(),
          ],
        }
      );

      this.init_data.einrichtung.giltFuerGesamt = this.build_giltFuerGesamt_string(true);
    });
  }

  ngOnDestroy(): void {
    this.eventsSubscription.unsubscribe();
  }

  // #region Save
  save() {
    if (this.isValid()) {
      this.startLoading(2);
      this.ajaxService.post<IDokumentItemViewModel>('api/Erlaubnis/BuildErlaubnis', this.init_data.einrichtung).subscribe({
        next: (response) => {
          if (response) {
            if (response.warningMessage) {
              notify({ message: response.warningMessage, type: 'warning', displayTime: 8000 });
            }
            if (!response.name) {
              this.stopLoading();
              return;
            }

            const re = /\./gi;
            const fileName =
              new Date()
                .toLocaleDateString('de-DE', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                })
                .replace(re, '-') + '_Betriebserlaubnis.pdf';
            this.ajaxService.download('/api/Dokument/Download?fileName=' + response.name + '&dokumentName=' + response.bezeichnung, fileName, () => {
              this.stopLoading();
              this.onCloseOk.emit(true);
            });
          }
        },
        error: (e) => {
          this.stopLoading();
          throw e;
        },
      });
    }
  }

  isValid(withMsg: boolean = true): boolean {
    if (this.form1) {
      const validationResult = this.form1.instance.validate();
      if (!validationResult.isValid) {
        if (withMsg) {
          let msg = '';
          for (const err of validationResult.brokenRules) {
            msg += err.message + '\r\n';
          }

          notify(
            {
              message: msg,
              width: 600,
            },
            'error',
            3000
          );
        }

        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
  // #endregion

  // #region Getter Plätze

  get getAllPlaetze(): number {
    // let result = 0;
    // for (let i = 0; i < this.init_data.he.einrichtungsteile.length; i++) {
    //   const et = this.init_data.he.einrichtungsteile[i];
    //   result += et.genehmigtePlaetze;
    // }

    // result = result >= 0 ? result : 0;
    //  return result;
    return this.init_data.einrichtung.einrichtungsteil.genehmigtePlaetze || 0;
  }

  get getAllSonstigeStellen(): number {
    // let result = 0;
    // for (let i = 0; i < this.init_data.he.einrichtungsteile.length; i++) {
    //   const et = this.init_data.he.einrichtungsteile[i];
    //   result += et.genehmigteSonstigeStellenAnteile;
    // }

    // result = result >= 0 ? result : 0;

    // return result;
    return this.init_data.einrichtung.einrichtungsteil.genehmigteSonstigeStellenAnteile || 0;
  }

  get getAllLeitStellen(): number {
    // let result = 0;
    // for (let i = 0; i < this.init_data.he.einrichtungsteile.length; i++) {
    //   const et = this.init_data.he.einrichtungsteile[i];
    //   result += et.genehmigteLeitungStellenAnteile;
    // }

    // result = result >= 0 ? result : 0;

    // return result;
    return this.init_data.einrichtung.einrichtungsteil.genehmigteLeitungStellenAnteile || 0;
  }

  get getAllPaedStellen(): number {
    // let result = 0;
    // for (let i = 0; i < this.init_data.he.einrichtungsteile.length; i++) {
    //   const et = this.init_data.he.einrichtungsteile[i];
    //   result += et.genehmigtePaedStellenAnteile;
    // }

    // result = result >= 0 ? result : 0;

    // return result;
    return this.init_data.einrichtung.einrichtungsteil.genehmigtePaedStellenAnteile || 0;
  }

  get getAllPsychStellen(): number {
    // let result = 0;
    // for (let i = 0; i < this.init_data.he.einrichtungsteile.length; i++) {
    //   const et = this.init_data.he.einrichtungsteile[i];
    //   result += et.genehmigtePsychStellenAnteile;
    // }

    // result = result >= 0 ? result : 0;

    // return result;
    return this.init_data.einrichtung.einrichtungsteil.genehmigtePsychStellenAnteile || 0;
  }

  get getAllTherapStellen(): number {
    // let result = 0;
    // for (let i = 0; i < this.init_data.he.einrichtungsteile.length; i++) {
    //   const et = this.init_data.he.einrichtungsteile[i];
    //   result += et.genehmigteTherapStellenAnteile;
    // }

    // return result;
    return this.init_data.einrichtung.einrichtungsteil.genehmigteTherapStellenAnteile || 0;
  }
  // #endregion

  // #region Sonstiges

  onEvent(event) {
    if (event === 'Save') {
      this.save();
    }
  }

  notEditable_checkBox_valueChanged(event) {
    this.notEditable = event.value;
    const item = this.form1.instance.getEditor('giltFuerGesamt').option('readOnly', event.value);

    if (!event.value) {
      this.set_giltFuerGesamt_string();
    }
  }

  notAutoUpdate_checkBox_valueChanged(event) {
    this.notAutoUpdate = event.value;
    if (!this.notAutoUpdate) {
      this.set_giltFuerGesamt_string();
    }
  }

  setOptional() {
    if (this.optional) {
      if (this.optional.antragBeId) {
        this.init_data.einrichtung.antragBeId = this.optional.antragBeId;
      }

      if (this.optional.inbetriebnahme) {
        this.init_data.einrichtung.inbetriebnahme = this.optional.inbetriebnahme;
      }

      if (this.optional.beWirkungVom) {
        this.init_data.einrichtung.betriebserlaubnisWirkungVom = this.optional.beWirkungVom;
      }

      if (this.optional.einrichtungsteil) {
        const et = this.optional.einrichtungsteil;
        const ue = this.init_data.einrichtung.einrichtungsteil;

        if (ue) {
          ue.genehmigtePlaetze = et.plaetze;
          ue.inbetriebnahme = et.inbetriebnahme;
        }
      }
    } else {
      this.init_data.einrichtung.einrichtungsteil.genehmigtePlaetze = 0;
    }
  }

  get available_AngebotsFormen(): IAngebotsFormViewvModel[] {
    if (this.init_data && this.init_data.einrichtung.angebotsGruppeId && this.init_data.available_AngebotsGruppen) {
      const result = this.init_data.available_AngebotsGruppen.find((x) => x.id === this.init_data.einrichtung.angebotsGruppeId);
      if (result) {
        return result.angebotsformen;
      }
    }

    return [];
  }

  startLoading(state: number) {
    this.loading = state;
  }

  stopLoading() {
    this.loading = 0;
  }

  // #endregion

  // #region GiltFuerGesamt

  set_giltFuerGesamt_string() {
    if (!this.notAutoUpdate) {
      const giltFuerGesamt_string = this.build_giltFuerGesamt_string();
      this.form1.instance.updateData('giltFuerGesamt', giltFuerGesamt_string);
    }
  }

  _giltFuerGesamt_string_raw_paedst_single = '[PAEDST] Stellen für pädagogische Fachkräfte';
  _giltFuerGesamt_string_raw_paedst_multi = '[PAEDST] Stellen für pädagogische Fachkräfte';

  // _giltFuerGesamt_string_raw_paedst_single2 = '[PAEDST] Stellen für pädagogische Fachkräfte, davon _ innewohnend';
  // _giltFuerGesamt_string_raw_paedst_multi2 = '[PAEDST] Stellen für pädagogische Fachkräfte, davon _ innewohnend';

  _giltFuerGesamt_string_raw_psychst_single = '[PSYCHST] Stellen für psychologische Fachkräfte';
  _giltFuerGesamt_string_raw_psychst_multi = '[PSYCHST] Stellen für psychologische Fachkräfte';

  _giltFuerGesamt_string_raw_therst_single = '[THERST] Stellen für therapeutische Fachkräfte';
  _giltFuerGesamt_string_raw_therst_multi = '[THERST] Stellen für therapeutische Fachkräfte';

  _giltFuerGesamt_string_raw_sonst_single = '[SONST] Stellen für sonstige Fachkräfte';
  _giltFuerGesamt_string_raw_sonst_multi = '[SONST] Stellen für sonstige Fachkräfte';

  _giltFuerGesamt_string_raw_leitst_single = '[LEITST] Stellen für pädagogische Leitung (Regelarbeitszeit entsprechend TVöD)';
  _giltFuerGesamt_string_raw_leitst_multi = '[LEITST] Stellen für pädagogische Leitung (Regelarbeitszeit entsprechend TVöD)';

  _giltFuerGesamt_string_raw_single = 'Die Betriebserlaubnis gilt für [PLÄTZE] Platz.\r\n Erforderlich sind mindestens:';
  _giltFuerGesamt_string_raw_multi = 'Die Betriebserlaubnis gilt für insgesamt [PLÄTZE] Plätze.\r\n Erforderlich sind mindestens:';

  build_giltFuerGesamt_string(forGesamt: boolean = false): string {
    let result = '';
    if (this.getAllPlaetze > 0 && this.getAllPlaetze < 2) {
      result = this._giltFuerGesamt_string_raw_single.replace('[PLÄTZE]', this.getAllPlaetze.toFixed(0).replace(/[.]/, ','));
    } else if (this.getAllPlaetze > 1) {
      result = this._giltFuerGesamt_string_raw_multi.replace('[PLÄTZE]', this.getAllPlaetze.toFixed(0).replace(/[.]/, ','));
    }

    if (this.getAllPaedStellen > 0 && this.getAllPaedStellen < 2) {
      // if (forGesamt === false) {
      result += '\r\n \t' + this._giltFuerGesamt_string_raw_paedst_single.replace('[PAEDST]', this.getAllPaedStellen.toFixed(3).replace(/[.]/, ','));
      // }
      // else {
      //   result += '\r\n \t' + this._giltFuerGesamt_string_raw_paedst_single2.replace('[PAEDST]', this.getAllPaedStellen.toFixed(3).replace(/[.]/,','));
      // }
    } else if (this.getAllPaedStellen > 1) {
      // if (forGesamt === false) {
      result += '\r\n \t' + this._giltFuerGesamt_string_raw_paedst_multi.replace('[PAEDST]', this.getAllPaedStellen.toFixed(3).replace(/[.]/, ','));
      // }
      // else {
      //   result += '\r\n \t' + this._giltFuerGesamt_string_raw_paedst_multi2.replace('[PAEDST]', this.getAllPaedStellen.toFixed(3).replace(/[.]/,','));
      // }
    }

    if (this.getAllPsychStellen > 0 && this.getAllPsychStellen < 2) {
      result += '\r\n \t' + this._giltFuerGesamt_string_raw_psychst_single.replace('[PSYCHST]', this.getAllPsychStellen.toFixed(3).replace(/[.]/, ','));
    } else if (this.getAllPsychStellen > 1) {
      result += '\r\n \t' + this._giltFuerGesamt_string_raw_psychst_multi.replace('[PSYCHST]', this.getAllPsychStellen.toFixed(3).replace(/[.]/, ','));
    }

    if (this.getAllTherapStellen > 0 && this.getAllTherapStellen < 2) {
      result += '\r\n \t' + this._giltFuerGesamt_string_raw_therst_single.replace('[THERST]', this.getAllTherapStellen.toFixed(3).replace(/[.]/, ','));
    } else if (this.getAllTherapStellen > 1) {
      result += '\r\n \t' + this._giltFuerGesamt_string_raw_therst_multi.replace('[THERST]', this.getAllTherapStellen.toFixed(3).replace(/[.]/, ','));
    }

    if (this.getAllSonstigeStellen > 0 && this.getAllSonstigeStellen < 2) {
      result += '\r\n \t' + this._giltFuerGesamt_string_raw_sonst_single.replace('[SONST]', this.getAllSonstigeStellen.toFixed(3).replace(/[.]/, ','));
    } else if (this.getAllSonstigeStellen > 1) {
      result += '\r\n \t' + this._giltFuerGesamt_string_raw_sonst_multi.replace('[SONST]', this.getAllSonstigeStellen.toFixed(3).replace(/[.]/, ','));
    }

    if (this.getAllLeitStellen > 0 && this.getAllLeitStellen < 2) {
      result += '\r\n \t' + this._giltFuerGesamt_string_raw_leitst_single.replace('[LEITST]', this.getAllLeitStellen.toFixed(3).replace(/[.]/, ','));
    } else if (this.getAllLeitStellen > 1) {
      result += '\r\n \t' + this._giltFuerGesamt_string_raw_leitst_multi.replace('[LEITST]', this.getAllLeitStellen.toFixed(3).replace(/[.]/, ','));
    }

    return result;
  }
  // #endregion
}
